// Typed answers of the single-product analysis (POST /product-scanner/{id}).
// Kept out of endpoints.ts so pages that mock endpoints can still use them.

/** 409 `ingredients_pending`: the team is still writing this product's ingredient list. */
export class ProductIngredientsPendingError extends Error {
  /** When the team should be done (RFC 3339), if the API knows. */
  deadlineAt?: string;
  constructor(deadlineAt?: string) {
    super('The ingredients of this product are still being checked');
    this.name = 'ProductIngredientsPendingError';
    if (deadlineAt) this.deadlineAt = deadlineAt;
  }
}

export function isProductIngredientsPendingError(error: unknown): error is ProductIngredientsPendingError {
  return error instanceof ProductIngredientsPendingError;
}

/** 400 `missing barcode`: the product has a barcode, and the caller must present it. */
export class BarcodeRequiredError extends Error {
  constructor() {
    super('Enter the barcode to view this result');
    this.name = 'BarcodeRequiredError';
  }
}

export function isBarcodeRequiredError(error: unknown): error is BarcodeRequiredError {
  return error instanceof BarcodeRequiredError;
}
